interface CallTimerProps {
  startTime?: number;
}

const formatDuration = (totalSeconds: number): string => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const pad = (n: number) => n.toString().padStart(2, '0');

  return hours > 0
    ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
    : `${pad(minutes)}:${pad(seconds)}`;
};

export const CallTimer = ({ startTime = 0 }: CallTimerProps) => {
  const [currentTime, setCurrentTime] = useState(new Date().getTime());

  const elapsedSeconds = startTime ? Math.floor((currentTime - startTime) / 1000) : 0;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime((prev) => prev + 1000);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (!startTime || elapsedSeconds < 0) {
    return null;
  }

  return <div>{formatDuration(elapsedSeconds)}</div>;
};

export default CallTimer;
